import { ShieldCheck } from "lucide-react";
import { XStack, YStack } from "tamagui";

import AuthScaffold, { AuthInfoPanel } from "@/components/AuthScaffold";
import MfaSettingsCard from "@/components/MfaSettingsCard";
import { useAuth } from "@/contexts/AuthContext";
import { AppButton, AppText } from "../../ui-foundation";

const SecureAccount = () => {
  const { role, signOut } = useAuth();
  const accessLabel = role === "admin" ? "admin" : "moderator";

  return (
    <AuthScaffold
      eyebrow="Secure your privileged access"
      title="Add two-step verification first."
      description={`Before Kindred unlocks ${accessLabel} tools on this account, add an authenticator app.`}
    >
      <YStack gap="$sm">
        <AuthInfoPanel>
          <XStack alignItems="flex-start" gap="$sm">
            <ShieldCheck size={16} className="mt-0.5 text-primary" />
            <AppText color="$colorMuted" fontSize="$sm" lineHeight="$md">
              This account can manage moderation, member safety, or admin content. Two-step verification is required before Kindred unlocks that access.
            </AppText>
          </XStack>
        </AuthInfoPanel>

        <MfaSettingsCard
          enforced
          enforcedReason="Privileged accounts must keep two-step verification on before Kindred unlocks admin or moderation tools."
        />

        <AppButton type="button" tone="outline" onPress={() => void signOut()} width="100%">
          Sign out instead
        </AppButton>
      </YStack>
    </AuthScaffold>
  );
};

export default SecureAccount;
